import { CoeDataAnalysisPackageConfigEncooList } from "src/models/coeDataAnalysisPackageConfig";
import { createEntityModel } from "src/store/models/entity/_shared";

export const CoeDataAnalysisPackageConfigEntityModel =
  createEntityModel<CoeDataAnalysisPackageConfigEncooList>();
